import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Components from '_components';
import { NavLink } from 'react-router';
import * as Styles from './Button.module.scss';
export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant[ButtonVariant["Custom"] = 0] = "Custom";
    ButtonVariant[ButtonVariant["Simple"] = 1] = "Simple";
    ButtonVariant[ButtonVariant["Small"] = 2] = "Small";
    ButtonVariant[ButtonVariant["Normal"] = 3] = "Normal";
})(ButtonVariant || (ButtonVariant = {}));
export function Button(props) {
    const contextVariant = React.useContext(ButtonAreaContext);
    const variant = props.variant ?? contextVariant;
    let content = props.children;
    if (variant === ButtonVariant.Custom) {
        content = props.children;
    }
    if (variant === ButtonVariant.Simple) {
        content = (_jsx(Components.BlockRow, { children: _jsx(Components.Block, { size: Components.BlockSize.Full, children: content }) }));
    }
    if (variant === ButtonVariant.Small) {
        content = (_jsxs(Components.BlockRow, { children: [_jsx(Components.Block, { size: Components.BlockSize.Full, children: content }), _jsx(Components.Block, { variant: Components.BlockVariant.Right })] }));
    }
    if (variant === ButtonVariant.Normal) {
        content = _jsx("span", { children: content });
    }
    if (props.link) {
        if (props.link.startsWith('/')) {
            return (_jsx(NavLink, { className: Styles.btn, to: props.link, children: content }));
        }
        else {
            return (_jsx("a", { className: Styles.btn, href: props.link, children: content }));
        }
    }
    else {
        return (_jsx("button", { className: Styles.btn, onClick: props.onClick, type: props.submit ? 'submit' : 'button', children: content }));
    }
}
const ButtonAreaContext = React.createContext(undefined);
export function ButtonArea(props) {
    return (_jsx(ButtonAreaContext.Provider, { value: props.variant, children: props.children }));
}
